export default __webpack_public_path__ + "static/media/btp-2-rMAX.33cf61c5.avif";